import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getMediaUrl } from '../../utils/api';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setDropdownOpen(false);
  };

  const initials = user
    ? `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`.toUpperCase()
    : '';

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">🌍</span>
          <span className="logo-text">
            <span className="logo-african">African</span>
            <span className="logo-marketplace"> Marketplace</span>
          </span>
        </Link>

        {/* Desktop Nav Links */}
        <div className="navbar-links">
          <Link to="/browse" className={`nav-link ${location.pathname === '/browse' ? 'active' : ''}`}>Browse</Link>
          <Link to="/browse?category=food-catering" className="nav-link">Food & Catering</Link>
          <Link to="/browse?category=hair-beauty" className="nav-link">Hair & Beauty</Link>
          <Link to="/browse?category=tailoring" className="nav-link">Tailoring</Link>
          <Link to="/browse?category=event-planning" className="nav-link">Events</Link>
        </div>

        {/* Desktop Actions */}
        <div className="navbar-actions">
          {user ? (
            <>
              <Link to="/messages" className="nav-icon-btn" title="Messages">💬</Link>
              {user.role === 'SELLER' && (
                <Link to="/dashboard/seller/create" className="btn btn-primary btn-sm">+ List Service</Link>
              )}
              <div className="user-menu">
                <button className="user-avatar-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
                  <div className="avatar">
                    {user.avatar
                      ? <img src={getMediaUrl(user.avatar)} alt={user.firstName} />
                      : initials
                    }
                  </div>
                  <span className="user-name">{user.firstName}</span>
                  <span className="dropdown-arrow">▾</span>
                </button>
                {dropdownOpen && (
                  <div className="dropdown-menu">
                    <div className="dropdown-header">
                      <strong>{user.firstName} {user.lastName}</strong>
                      <span className="dropdown-email">{user.email}</span>
                    </div>
                    <div className="dropdown-divider" />
                    <Link to="/profile" className="dropdown-item" onClick={() => setDropdownOpen(false)}>👤 My Profile</Link>
                    {user.role === 'BUYER' && (
                      <Link to="/dashboard/buyer" className="dropdown-item" onClick={() => setDropdownOpen(false)}>📦 My Orders</Link>
                    )}
                    {(user.role === 'SELLER') && (
                      <Link to="/dashboard/seller" className="dropdown-item" onClick={() => setDropdownOpen(false)}>🏪 Seller Dashboard</Link>
                    )}
                    {user.role === 'ADMIN' && (
                      <Link to="/admin" className="dropdown-item" onClick={() => setDropdownOpen(false)}>⚙️ Admin Panel</Link>
                    )}
                    <Link to="/messages" className="dropdown-item" onClick={() => setDropdownOpen(false)}>💬 Messages</Link>
                    <div className="dropdown-divider" />
                    <button className="dropdown-item dropdown-logout" onClick={handleLogout}>🚪 Sign Out</button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-ghost btn-sm">Sign In</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Get Started</Link>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/browse" className="mobile-link" onClick={() => setMenuOpen(false)}>Browse All</Link>
          <Link to="/browse?category=food-catering" className="mobile-link" onClick={() => setMenuOpen(false)}>🍛 Food & Catering</Link>
          <Link to="/browse?category=hair-beauty" className="mobile-link" onClick={() => setMenuOpen(false)}>💇 Hair & Beauty</Link>
          <Link to="/browse?category=tailoring" className="mobile-link" onClick={() => setMenuOpen(false)}>🧵 Tailoring</Link>
          <Link to="/browse?category=event-planning" className="mobile-link" onClick={() => setMenuOpen(false)}>🎉 Event Planning</Link>
          {user ? (
            <>
              <div className="mobile-divider" />
              <Link to="/profile" className="mobile-link" onClick={() => setMenuOpen(false)}>My Profile</Link>
              {user.role === 'BUYER' && <Link to="/dashboard/buyer" className="mobile-link" onClick={() => setMenuOpen(false)}>My Orders</Link>}
              {user.role === 'SELLER' && <Link to="/dashboard/seller" className="mobile-link" onClick={() => setMenuOpen(false)}>Seller Dashboard</Link>}
              {user.role === 'ADMIN' && <Link to="/admin" className="mobile-link" onClick={() => setMenuOpen(false)}>Admin Panel</Link>}
              <button className="mobile-link mobile-logout" onClick={() => { handleLogout(); setMenuOpen(false); }}>Sign Out</button>
            </>
          ) : (
            <>
              <div className="mobile-divider" />
              <Link to="/login" className="mobile-link" onClick={() => setMenuOpen(false)}>Sign In</Link>
              <Link to="/register" className="mobile-link mobile-register" onClick={() => setMenuOpen(false)}>Get Started</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
